import React from 'react';
import BaseNode from './BaseBlockNode';
import { buildSourceInfoMarkers, renderValue } from '../../helpers/node';
import { PARAMS_LABEL } from '../../../constants';

function StorageNode(props) {
  const {
    withHardConstraint,
    withMeasurementPoint,
    maxLoad,
    maxCapacity,
    nominalVoltage,
    presentLoad,
    // presentCapacity
  } = props;

  return (
    <BaseNode
      {...props}
      phases={null}
      infoMarkers={
        buildSourceInfoMarkers({ withHardConstraint, withMeasurementPoint })
      }
      staticParams={[
        { label: 'Max Load', value: renderValue(maxLoad, 'A') },
        { label: 'Nominal Voltage', value: renderValue(nominalVoltage, 'V') },
        { label: 'Max Capacity', value: renderValue(maxCapacity, 'kWh') },
      ]}
      dynamicParams={[
        { label: PARAMS_LABEL.presentLoad, value: renderValue(presentLoad, 'A') },
        // { label: 'Present Capacity', value: renderValue(presentCapacity, 'kWh') },
      ]}
    />
  );
}

export default StorageNode;
